import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import classes from './MotorDataVoltageItems.css';
import ListItemTR from '../../../UI/ListItems/TwoRowsListItem/ListItemTR';
import LocalizedStrings from '../../../../assets/data/LocalizedStrings/LocalizedStrings.json';

const parsePhaseURI = URIelement => {
  let phase = URIelement;
  phase = phase.replace(/-/g, '/');
  phase = `${phase.substr(0, phase.length - 2)} ${phase.substr(-2)}`;
  return phase;
};

const motorDataVoltageItems = props => {
  const { match, selectedES, country, language } = props;

  const SinglePhase115V = require(`../../../../assets/data/AppData/${country}/MotorData/SinglePhase/SinglePhase115V.json`),
    SinglePhase230V = require(`../../../../assets/data/AppData/${country}/MotorData/SinglePhase/SinglePhase230V.json`),
    ThreePhase208V = require(`../../../../assets/data/AppData/${country}/MotorData/ThreePhase/ThreePhase208V.json`),
    ThreePhase240V = require(`../../../../assets/data/AppData/${country}/MotorData/ThreePhase/ThreePhase240V.json`),
    ThreePhase480V = require(`../../../../assets/data/AppData/${country}/MotorData/ThreePhase/ThreePhase480V.json`),
    ThreePhase600V = require(`../../../../assets/data/AppData/${country}/MotorData/ThreePhase/ThreePhase600V.json`);

  const selectedVoltage = parsePhaseURI(match.params.voltage);
  let phaseData = SinglePhase115V;
  let title = `${LocalizedStrings[language].sp} 115V`;

  switch (props.match.params.key) {
    case 'SP115V':
      title = `${LocalizedStrings[language].sp} 115V`;
      phaseData = SinglePhase115V;
      break;
    case 'SP230V':
      title = `${LocalizedStrings[language].sp} 230V`;
      phaseData = SinglePhase230V;
      break;
    case 'TP208V':
      title = `${LocalizedStrings[language].tp} 208V`;
      phaseData = ThreePhase208V;
      break;
    case 'TP240V':
      title = `${LocalizedStrings[language].tp} 240V`;
      phaseData = ThreePhase240V;
      break;
    case 'TP480V':
      title = `${LocalizedStrings[language].tp} 480V`;
      phaseData = ThreePhase480V;
      break;
    case 'TP600V':
      title = `${LocalizedStrings[language].tp} 600V`;
      phaseData = ThreePhase600V;
      break;
    default:
      title = `${LocalizedStrings[language].sp} 115V`;
      phaseData = SinglePhase115V;
      break;
  }

  const generalItems = Object.keys(phaseData[selectedVoltage][0])
    .map(item =>
      [...Array(phaseData[selectedVoltage][0][item])].map((_, i) => (
        <ListItemTR
          key={item + i}
          title={LocalizedStrings[language][item]}
          value={phaseData[selectedVoltage][0][item]}
        />
      ))
    )
    .reduce((arr, el) => arr.concat(el), []);

  const enclosedItems = Object.keys(phaseData[selectedVoltage][1]).map(item =>
    [...Array(phaseData[selectedVoltage][1][item])]
      .map((_, i) => (
        <ListItemTR
          key={item + i}
          title={LocalizedStrings[language][item]}
          value = {phaseData[selectedVoltage][1][item]}
          country={country}
          language={language}
        />
      ))
      .reduce((arr, el) => arr.concat(el), [])
  );

  const openItems = Object.keys(phaseData[selectedVoltage][2]).map(item =>
    [...Array(phaseData[selectedVoltage][2][item])]
      .map((_, i) => (
        <ListItemTR
          key={item + i}
          title={LocalizedStrings[language][item]}
          value={phaseData[selectedVoltage][2][item]}
          country={country}
          language={language}
        />
      ))
      .reduce((arr, el) => arr.concat(el), [])
  );

  return (
    <Fragment>
      <ul className={classes.MotorDataVoltageItems}>
        {generalItems}
        {selectedES ? enclosedItems : openItems}
      </ul>
      <div className={classes.TitleWrapper}>
        <h3>{title}</h3>
      </div>
    </Fragment>
  );
};

motorDataVoltageItems.propTypes = {
  match: PropTypes.any.isRequired,
  selectedES: PropTypes.bool.isRequired,
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired
};

export default withRouter(motorDataVoltageItems);
